import {ChargingPaymentMethodInterface} from '../interfaces/charging-payment-method.interface';

export class SetTopUpPaymentMethodAction {
  static readonly type = '[Payment] Set top up payment method';

  constructor(public paymentMethod: ChargingPaymentMethodInterface) {
  }
}
